import React, { useEffect, useState, useMemo } from "react";
import Pagination from "react-bootstrap/Pagination";
import {Button, Row, ButtonGroup, Col} from "reactstrap";

const PaginationComponent = ({
    total = 0,
    itemsPerPage = 10,
    currentPage = 1,
    onPageChange
}) => {
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        if (total > 0 && itemsPerPage > 0)
            setTotalPages(Math.ceil(total / itemsPerPage));
    }, [total, itemsPerPage]);

    const paginationItems = useMemo(() => {
        const pages = [];

        for (let i = 1; i <= totalPages; i++) {
            pages.push(
                <Pagination.Item
                    key={i}
                    active={i === currentPage}
                    onClick={() => onPageChange(i)}
                >
                    {i}
                </Pagination.Item>
            );
        }

        return pages;
    }, [totalPages, currentPage]);

    if (totalPages === 0) return null;

    return (
        <>
        <div>
            <Row>
        <Col sm={8}>
            <ButtonGroup>
              {/* Se ven deshabilitados pero sin el atributo disabled: el navegador
                  no muestra el tooltip de un boton disabled */}
              <Button
                size="sm"
                color="danger"
                className={currentPage <= 1 ? "btn disabled" : "btn"}
                aria-disabled={currentPage <= 1}
                style={currentPage <= 1 ? { cursor: "not-allowed" } : undefined}
                title={currentPage <= 1 ? "Ya estas en la primera pagina" : "Pagina anterior"}
                onClick={() => {
                  if (currentPage > 1) onPageChange(currentPage - 1);
                }}
              >
                <i class="fas fa-arrow-left"></i>
              </Button>
              <Button
                size="sm"
                color="info"
                className={currentPage >= totalPages ? "btn disabled" : "btn"}
                aria-disabled={currentPage >= totalPages}
                style={currentPage >= totalPages ? { cursor: "not-allowed" } : undefined}
                title={currentPage >= totalPages ? "Ya estas en la ultima pagina" : "Pagina siguiente"}
                onClick={() => {
                  if (currentPage < totalPages) onPageChange(currentPage + 1);
                }}
              >
                <i class="fas fa-arrow-right"></i>
              </Button>
              </ButtonGroup>
              <h5>Pagina {currentPage} de {totalPages}</h5>
              </Col>
              </Row>
        </div>
        </>
    );
};
        {/* <Pagination size="sm">
            <Pagination.Prev
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            />
            {paginationItems}
            <Pagination.Next
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            />
        </Pagination> */}
export default PaginationComponent;